import { render } from "./EditEnterpriseUser.vue?vue&type=template&id=b24630f4"
import script from "./EditEnterpriseUser.vue?vue&type=script&lang=js"
export * from "./EditEnterpriseUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__